import { Button } from "components/ui/button";
import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from "components/ui/popover";
import { cn } from "lib/utils";
import { useTranslation } from "react-i18next";

interface ClassNameProps {
  buttonWithIcon: string;
  buttonWithIconHover: string;
  iconStylesOpen: string;
  iconStylesClose: string;
  buttonYes: string;
  buttonCancel: string;
}

export default function DeleteButtonPopup({
  id,
  actionYes = () => {},
  isLoading = false,
  question = "",
  classNames,
  open = false,
  setOpen = () => {},
}: {
  id: number;
  actionYes?: (id: number) => void;
  isLoading?: boolean;
  question?: React.ReactNode;
  classNames?: ClassNameProps;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}) {
  const { t } = useTranslation();

  return (
    <Popover onOpenChange={setOpen} open={open}>
      <PopoverTrigger asChild disabled={isLoading}>
        <Button
          className={cn(
            "h-[54px] w-[54px] p-0",
            open ? classNames?.buttonWithIconHover : classNames?.buttonWithIcon
          )}
          icon="trash"
          iconStyles={cn(
            "w-6 h-6",
            open ? classNames?.iconStylesOpen : classNames?.iconStylesClose
          )}
          variant="secondary"
        />
      </PopoverTrigger>
      <PopoverContent
        align="center"
        className="flex flex-col gap-4 !bg-[#1F384C] text-white"
        noPortal
        onInteractOutside={(e) => {
          if (isLoading) e.preventDefault();
        }}
        onScroll={() => setOpen(false)}
        side="bottom"
      >
        <span className="text-sm">{question}</span>
        <div className="flex flex-row w-full justify-start items-start gap-4 !bg-[#1F384C]">
          <Button
            className={classNames?.buttonYes}
            loading={isLoading}
            onClick={() => {
              actionYes(id);
              setOpen(false);
            }}
          >
            {t("yes_sure")}
          </Button>
          <Button
            className={classNames?.buttonCancel}
            disabled={isLoading}
            onClick={() => setOpen(false)}
          >
            {t("cancel")}
          </Button>
        </div>
        <PopoverArrow style={{ fill: "!#1F384C" }} />
      </PopoverContent>
    </Popover>
  );
}
